import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink } from "lucide-react";

export default function AffiliateSidebar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/affiliates").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="sticky top-24 space-y-4" data-testid="affiliate-sidebar">
      <div className="text-xs uppercase tracking-widest text-stone-500 font-medium px-1">
        Sponsored Resources
      </div>

      {items.length === 0 ? (
        <div className="rounded-md border border-dashed border-stone-300 bg-white p-6 text-sm text-stone-500 text-center">
          Sponsored resources will appear here.
        </div>
      ) : (
        items.map((a) => (
          <a
            key={a.id}
            href={a.url}
            target="_blank"
            rel="noopener sponsored noreferrer"
            data-testid={`affiliate-card-${a.id}`}
            className="group relative block overflow-hidden rounded-md border border-stone-200 bg-white transition-all hover:-translate-y-0.5 hover:shadow-sm"
          >
            {a.image_url ? (
              <div className="relative h-32 w-full overflow-hidden">
                <img src={a.image_url} alt="" className="h-full w-full object-cover transition-transform group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/70 to-stone-900/10" />
                <div className="absolute inset-x-0 bottom-0 p-3">
                  <div className="font-serif text-lg text-white leading-tight">{a.title}</div>
                </div>
              </div>
            ) : (
              <div className="p-4 pb-0">
                <div className="font-serif text-lg text-stone-900 leading-tight">{a.title}</div>
              </div>
            )}
            <div className="p-4 pt-3">
              <p className="text-sm text-stone-600 leading-relaxed line-clamp-3">{a.description}</p>
              <div className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary group-hover:underline">
                Visit <ExternalLink className="h-3 w-3" strokeWidth={1.5} />
              </div>
            </div>
          </a>
        ))
      )}
    </div>
  );
}
